import {AutomationChoose} from '../../reducer/model';
import {texts} from '../../texts';

export const functionsOptions = [
    {title: 'BEGINOFMONTH(date)', description: 'start of month', value: 'BEGINOFMONTH(date)'},
    {title: 'ENDOFMONTH(date)', description: 'end of month', value: 'ENDOFMONTH(date)'},
    {title: 'BEGINOFYEAR(date)', description: 'start of year', value: 'BEGINOFYEAR(date)'},
    {title: 'ENDOFYEAR(date)', description: 'end of year', value: 'ENDOFYEAR(date)'},
    {title: 'BEGINOFQUARTER(date)', description: 'start of quarter', value: 'BEGINOFQUARTER(date)'},
    {title: 'ENDOFQUARTER(date)', description: 'end of quarter', value: 'ENDOFQUARTER(date)'},
    {title: 'MAXOP(number1, number2)', description: 'maximum', value: 'MAXOP(number1, number2)'},
    {title: 'MINOP(number1, number2)', description: 'minimu', value: 'MINOP(number1, number2)'}
];

export const predefinedExpressionOptions = [
    {
        title: 'current date (w/o time)',
        description: 'Condition	Description',
        value: 'current date (w/o time)'
    },
    {title: 'SQL.DATE8', description: 'current date (w/o time)', value: 'SQL.DATE8'},
    {title: 'SQL.DATE', description: 'current date and time', value: 'SQL.DATE'},
    {title: 'SQL.TIME', description: 'current time', value: 'SQL.TIME'},
    {title: '24:00', description: 'full day', value: '24:00'},
    {title: 'SQL.DAY', description: 'current weekday', value: 'SQL.DAY'},
    {title: 'SQL.DIR', description: 'current company', value: 'SQL.DIR'},
    {
        title: 'BEGINOFMONTH(SQL.DATE)',
        description: 'start of this month',
        value: 'BEGINOFMONTH(SQL.DATE)'
    },
    {
        title: '(ENDOFMONTH(SQL.DATE) + 24:00)',
        description: 'start of next month',
        value: '(ENDOFMONTH(SQL.DATE) + 24:00)'
    },
    {
        title: 'BEGINOFMONTH(BEGINOFMONTH(SQL.DATE) - 24:00)',
        description: 'start of last month',
        value: 'BEGINOFMONTH(BEGINOFMONTH(SQL.DATE) - 24:00)'
    },
    {
        title: 'ENDOFMONTH(SQL.DATE)',
        description: 'end of this month',
        value: 'ENDOFMONTH(SQL.DATE)'
    },
    {
        title: 'ENDOFMONTH(ENDOFMONTH(SQL.DATE) + 24:00)',
        description: 'end of next month',
        value: 'ENDOFMONTH(ENDOFMONTH(SQL.DATE) + 24:00)'
    },
    {
        title: '(BEGINOFMONTH(SQL.DATE) - 24:00)',
        description: 'end of last month',
        value: '(BEGINOFMONTH(SQL.DATE) - 24:00)'
    },
    {
        title: 'BEGINOFQUARTER(SQL.DATE)',
        description: 'start of this quarter',
        value: 'BEGINOFQUARTER(SQL.DATE)'
    },
    {
        title: '(ENDOFQUARTER(SQL.DATE) + 24:00)',
        description: 'start of next quarter',
        value: '(ENDOFQUARTER(SQL.DATE) + 24:00)'
    },
    {
        title: 'BEGINOFQUARTER(BEGINOFQUARTER(SQL.DATE) - 24:00)',
        description: 'start of last quarter',
        value: 'BEGINOFQUARTER(BEGINOFQUARTER(SQL.DATE) - 24:00)'
    },
    {
        title: 'ENDOFQUARTER(SQL.DATE)',
        description: 'end of this quarter',
        value: 'ENDOFQUARTER(SQL.DATE)'
    },
    {
        title: 'ENDOFQUARTER(ENDOFQUARTER(SQL.DATE) + 24:00)',
        description: 'end of next quarter',
        value: 'ENDOFQUARTER(ENDOFQUARTER(SQL.DATE) + 24:00)'
    },
    {
        title: '(BEGINOFQUARTER(SQL.DATE) - 24:00)',
        description: 'end of last quarter',
        value: '(BEGINOFQUARTER(SQL.DATE) - 24:00)'
    },
    {
        title: 'BEGINOFWEEK(WEEK(SQL.DATE))',
        description: 'start of this week',
        value: 'BEGINOFWEEK(WEEK(SQL.DATE))'
    },
    {
        title: 'BEGINOFWEEK(WEEK(SQL.DATE) + 1)',
        description: 'start of next week',
        value: 'BEGINOFWEEK(WEEK(SQL.DATE) + 1)'
    },
    {
        title: 'BEGINOFWEEK(WEEK(SQL.DATE) - 1)',
        description: 'start of last week',
        value: 'BEGINOFWEEK(WEEK(SQL.DATE) - 1)'
    },
    {
        title: '(BEGINOFWEEK(WEEK(SQL.DATE)+1) - 24:00)',
        description: 'end of this week',
        value: '(BEGINOFWEEK(WEEK(SQL.DATE)+1) - 24:00)'
    },
    {
        title: '(BEGINOFWEEK(WEEK(SQL.DATE)+2) - 24:00)',
        description: 'end of next week',
        value: '(BEGINOFWEEK(WEEK(SQL.DATE)+2) - 24:00)'
    },
    {
        title: '(BEGINOFWEEK(WEEK(SQL.DATE)) - 24:00)',
        description: 'end of last week',
        value: '(BEGINOFWEEK(WEEK(SQL.DATE)) - 24:00)'
    },
    {
        title: 'BEGINOFYEAR(SQL.DATE)',
        description: 'start of this year',
        value: 'BEGINOFYEAR(SQL.DATE)'
    },
    {
        title: '(ENDOFYEAR(SQL.DATE) + 24:00)',
        description: 'start of next year',
        value: '(ENDOFYEAR(SQL.DATE) + 24:00)'
    },
    {
        title: 'BEGINOFYEAR(BEGINOFYEAR(SQL.DATE) - 24:00)',
        description: 'start of last year',
        value: 'BEGINOFYEAR(BEGINOFYEAR(SQL.DATE) - 24:00)'
    },
    {title: 'ENDOFYEAR(SQL.DATE)', description: 'end of this year', value: 'ENDOFYEAR(SQL.DATE)'},
    {
        title: 'ENDOFYEAR(ENDOFYEAR(SQL.DATE) + 24:00)',
        description: 'end of next year',
        value: 'ENDOFYEAR(ENDOFYEAR(SQL.DATE) + 24:00)'
    },
    {
        title: '(BEGINOFYEAR(SQL.DATE) - 24:00)',
        description: 'end of last year',
        value: '(BEGINOFYEAR(SQL.DATE) - 24:00)'
    },
    {title: '(SQL.DATE8 + 24:00)', description: 'tomorrow', value: '(SQL.DATE8 + 24:00)'},
    {
        title: '(SQL.DATE8 + 2 * 24:00)',
        description: 'day after tomorrow',
        value: '(SQL.DATE8 + 2 * 24:00)'
    },
    {title: '(SQL.DATE8 - 24:00)', description: 'yesterday', value: '(SQL.DATE8 - 24:00)'}
];

export type TabsDataItem = {
    id: string;
    title: string;
    data: Array<AutomationChoose>;
};

export const tabsData = (
    columns: AutomationChoose[],
    functionsOptions: AutomationChoose[],
    predefinedExpressionOptions: AutomationChoose[]
): Array<TabsDataItem> => [
    {
        id: 'fields',
        title: texts.input_field_label,
        data: columns
    },
    {
        id: 'function',
        title: texts.function_dialog_tab_function_label,
        data: functionsOptions
    },
    {
        id: 'expressions',
        title: texts.function_dialog_tab_predefinedEpx_label,
        data: predefinedExpressionOptions
    }
];

export const tabsDataFunctionDialog = (
    columns: AutomationChoose[],
    functionsOptions: AutomationChoose[]
): Array<TabsDataItem> => [
    {
        id: 'fields',
        title: texts.input_field_label,
        data: columns
    },
    {
        id: 'function',
        title: texts.function_dialog_tab_function_label,
        data: functionsOptions
    }
];
